(function () {
  var RADIUS = 170;
  var PULL = 0.34;

  function bind(root) {
    if (!root || root.dataset.nkBound === '1') return;
    if (!root.classList.contains('urb-nk--magnet')) return;

    var cta = root.querySelector('.urb-nk__cta');
    if (!cta) return;

    var raf = null;
    var last = null;

    function frame() {
      raf = null;
      if (!last) return;
      var r = cta.getBoundingClientRect();
      var dx = last.clientX - (r.left + r.width / 2);
      var dy = last.clientY - (r.top + r.height / 2);
      var dist = Math.sqrt(dx * dx + dy * dy);
      var f = dist < RADIUS ? (1 - dist / RADIUS) : 0;
      cta.style.setProperty('--nk-mx', (dx * PULL * f).toFixed(1) + 'px');
      cta.style.setProperty('--nk-my', (dy * PULL * f).toFixed(1) + 'px');
    }

    root.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      last = e;
      if (!raf) raf = requestAnimationFrame(frame);
    });

    root.addEventListener('pointerleave', function () {
      last = null;
      cta.style.setProperty('--nk-mx', '0px');
      cta.style.setProperty('--nk-my', '0px');
    });

    root.dataset.nkBound = '1';
  }

  function init(scope) {
    var host = scope || document;
    var nodes = host.querySelectorAll ? host.querySelectorAll('[data-urb-nk]') : [];
    for (var i = 0; i < nodes.length; i++) bind(nodes[i]);
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(pointer: fine)').matches) return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
